import React from 'react'
import { Typography } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'

export interface CommissionVisualizationProps {
  agentShare: number
  agentTitle: string
  customerDiscount: number
  customerTitle: string
  className?: string
  ownerTitle: string
  ownerPercentage: number
}

export function CommissionVisualization({
  agentShare = 25,
  agentTitle,
  customerDiscount = 25,
  customerTitle,
  ownerTitle,
  ownerPercentage = 50,
  className,
}: CommissionVisualizationProps) {
  const agentPercentage = agentShare
  const customerPercentage = customerDiscount
  return (
    <div className={cn('w-full', className)}>
      <div className='flex items-center gap-1'>
        {customerPercentage > 0 && (
          <div
            className='h-5 rounded-lg bg-positive-main relative flex items-center justify-center transition-all duration-300'
            style={{ width: `${customerDiscount}%` }}
          >
            {customerPercentage > 25 ? (
              <Typography size='2xs'>
                {customerTitle} {customerDiscount}٪
              </Typography>
            ) : (
              <div className='absolute -top-8 left-1/2 transform -translate-x-1/2 z-10 whitespace-nowrap'>
                <Typography size='2xs'>
                  {customerTitle} {customerDiscount}٪
                </Typography>

                <div className='w-px h-4 bg-positive-main mx-auto' />
              </div>
            )}
          </div>
        )}

        {agentShare > 0 && (
          <div
            className='h-5 rounded-lg flex  bg-base-main relative items-center justify-center transition-all duration-300'
            style={{ width: `${agentPercentage}%` }}
          >
            {agentShare >= 25 ? (
              <Typography
                size='2xs'
                color='text-base-main-100'
                className='ml-2'
              >
                {agentTitle} {agentShare}٪
              </Typography>
            ) : (
              <div className='absolute -top-8 left-1/2 transform -translate-x-1/2 z-10 whitespace-nowrap'>
                <Typography size='2xs'>
                  {agentTitle} {agentShare}٪
                </Typography>

                <div className='w-px h-4 bg-base-main mx-auto' />
              </div>
            )}
          </div>
        )}

        <div
          className='h-5 rounded-lg flex  bg-base-surface items-center justify-center transition-all duration-300'
          style={{
            width: `${ownerPercentage}%`,
          }}
        >
          <Typography size='2xs'>
            {ownerTitle} {ownerPercentage}٪
          </Typography>
        </div>
      </div>
    </div>
  )
}
